export default __webpack_public_path__ + "media/images/face-f75eed829219817a9b2385e13b26a371.jpg";